import { select, put } from 'redux-saga/effects';

import {
    validationSelector,
    visibilitySelector
} from 'ctm-selectors';

import { getPageRules } from '../state_selectors';

/**
 * Saga to validate the form
 * @param {Object} action - The action that describes the requested validation.
 * @returns {Boolean} true if the form is valid, false otherwise
 */
export const validateForm = function* (action) {
    const { pageName, stateKey } = action;
    const rules = yield select(getPageRules, pageName);
    const visibility = yield select(visibilitySelector, stateKey);

    yield put({ type: 'VALIDATE_PAGE', pageName, visibility, rules, stateKey });

    const validation = yield select(validationSelector, stateKey);
    return validation.getIn(['pages', pageName]);
};
